<template>
  <div v-if="group != null" id="show-group-background">
    <div>
      <v-dialog v-model="dialogForBackground" persistent max-width="300">
        <template v-slot:activator="{ on }">
          <v-btn v-if="isGrantedUser()" v-on="on" text :loading="loading">
            <v-icon left>mdi-upload</v-icon>
            Charger
          </v-btn>
          <v-btn
            v-if="isGrantedUser()"
            :disabled="!hasResource"
            text
            @click="openDeleteDialog(group)"
            :loading="loading"
          >
            <v-icon left>mdi-delete</v-icon>
            Supprimer
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="primary-background">
            <span>Chargement du fond</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="backgroundFormRef">
              <v-file-input
                :rules="background_fileRules"
                v-model="backgroundFile"
                label="Fond"
              ></v-file-input>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogForBackground = false">
              Fermer
            </v-btn>
            <v-btn color="primary" @click="triggerUploadBackground">
              Enregistrer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <delete-dialog
      :open.sync="deleteDialog"
      v-on:delete="triggerRemoveBackground"
    >
      <template #title>
        Suppression du fond pour {{ group.description }}
      </template>
      Vous êtes sur le point de supprimer le fond de ce groupe. Tous les
      portails hérités de ce groupe seront affectés. Voulez-vous continuer ?
    </delete-dialog>
  </div>
</template>
<script>
import { toRefs, ref, computed } from "@vue/composition-api";
import { useGroupBackground } from "../../composables/group-background";
import DeleteDialog from "@/components/General/DeleteDialog.vue";
import { useRoles } from "../../composables/roles";

export default {
  props: {
    group: Object,
  },
  components: {
    DeleteDialog,
  },
  setup(props, { emit }) {
    /* Import des API */
    const {
      groupBackgroundData,
      uploadBackground,
      removeBackground,
    } = useGroupBackground();
    const { isGrantedUser } = useRoles();

    /* Variables */
    const loading = ref(false);

    /* Computed */
    const hasResource = computed(function () {
      return props.group.backgroundPath.indexOf("/background") > -1;
    });

    /* Méthodes */
    const openDeleteDialog = function (portal) {
      groupBackgroundData.deleteDialog = true;
      groupBackgroundData.editedItem = { ...portal };
    };
    const closeDeleteDialog = function () {
      groupBackgroundData.deleteDialog = false;
      groupBackgroundData.editedItem = null;
    };
    const triggerRemoveBackground = async function () {
      loading.value = true;
      await removeBackground(groupBackgroundData.editedItem.id);
      loading.value = false;
      closeDeleteDialog();
      emit("refresh-preview");
    };
    const triggerUploadBackground = async function () {
      groupBackgroundData.dialogForBackground = false;
      loading.value = true;
      await uploadBackground(props.group.id);
      loading.value = false;
      emit("refresh-preview");
    };

    return {
      uploadBackground,
      removeBackground,
      ...toRefs(groupBackgroundData),
      loading,
      hasResource,
      openDeleteDialog,
      triggerRemoveBackground,
      triggerUploadBackground,
      isGrantedUser,
    };
  },
};
</script>
